import UploadIcon from '@atlaskit/icon/core/upload';
import * as React from 'react';

export function SvgUpload() {
  return <UploadIcon label="" testId="ads-refreshed-icon" />;
}
